import { Component, OnInit, TemplateRef,ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { UserService,JwtService,User } from '../../shared';
import { environment } from '../../shared/config/app-config';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';


@Component({
  templateUrl: 'dashboard2.component.html',
  styleUrls: ['./style.component.css']
  
  
})

export class DashboarddComponent implements OnInit {
  imageURL: string = environment.cloudeImageURL;
  public data: Object;
  modalRef: BsModalRef;
  resp:any;
  care:any;
  count:any;
  surveyform:any;
  temp_var:any;
  type = 'bulletinboard';
  bulletinboard:any;
  apiurl:any = environment.api_url;
  carepath:any;
  documenturl:string = environment.documenturl;
  @ViewChild('videoPlayer') videoplayer: any;
  requiredcount:number = 0;
  suggestedcount:number = 0;
  CurrentUser:User;
  constructor(
    private route:ActivatedRoute,
    private router: Router,
    private modalService: BsModalService,
    private userService:UserService,
    private jwtService: JwtService
    
  ) {
    
  }

  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template,{backdrop: 'static'});
  }
  
  
  ngOnInit() {
    
  //this.jwtService.getworkflow()  
  this.userService.currentUser.subscribe(
    (userData) => {
      this.CurrentUser = userData;
      this.CurrentUser.status = false
    }
  )
  if(this.CurrentUser.item.hostModel=="CLOUD")
  this.imageURL = environment.cloudeImageURL;
else   
  this.imageURL = environment.vmImageURL;

  if(this.route.snapshot.url[0].path != 'assessment'){
    this.CurrentUser.operationStatus = ''
  }
   this.userService.PUser.subscribe(
    (user) => {
      this.resp = user;
    }
  )   
  this.userService.getcarepath(window.localStorage['Puser'])
  .subscribe(
    data => {
      
      this.carepath = data;
      for(var i=0;i<data.length;i++){
        if(data[i].priorityId != 4){
          this.requiredcount++;
        }
        else{
          this.suggestedcount++;
        }
        this.count = this.requiredcount+this.suggestedcount;
      }
      if(this.carepath.length >= 1){
        this.temp_var = 1;
       
      }
      else{
        this.temp_var = 0;
       
      }
      
    }
    
  );
  this.userService.getbulletindashboard(this.type,window.localStorage['Puser'])
    .subscribe(
      data => {
        this.bulletinboard = data;
        //////console.log( this.bulletinboard);
        
      }
      
    );
    
  }
  video(template: TemplateRef<any>,video) {
    this.modalRef = this.modalService.show(template,{backdrop: 'static'});
    this.care = video;
  }
  pauseOrPlay(video){
    video.pause();
    video.currentTime = 0;
    this.modalRef.hide();
    this.userService.updatesurvey(this.care.patientVideoMappingId,this.care.type)
    .subscribe(
      data => {
        this.surveyform = data; 
        //////console.log(data);
        if(data.updateStatus == "true"){
          this.userService.logAudit("updatereviewstatus",0).subscribe(data =>{})
          if(window.localStorage['Puser']){
            this.userService.getusersession()
            .subscribe(
             data => {
               if(data)
                this.userService.setUser(data[0].patientStageWorkflow[0]);
             },
             err => this.userService.purgeAuth()
           );
          }
        this.userService.getcarepath(window.localStorage['Puser'])
        .subscribe(
          data => {
            
            this.carepath = data;
            for(var i=0;i<data.length;i++){
              if(data[i].priorityId != 4){
                this.requiredcount++;
              }
              else{
                this.suggestedcount++;
              }
              this.count = this.requiredcount+this.suggestedcount;
            }
            if(this.carepath.length > 1){
              this.temp_var = 1;
             
            }
            else{
              this.temp_var = 0;
             
            }
            
          }
          
        );
      }
      else{
        
      } 
      });
} 
 
}
  

   
 
  

